"use strict";

require("core-js/modules/es.array.iterator");

var go = require("./go.js");

var filterL = require("../Lazy/filterL.js");

var mapL = require("../Lazy/mapL.js");

var head = require("./head.js");

module.exports = cond;

function cond(...fns) {
  return (...args) => go(fns, filterL(([c]) => c(...args)), mapL(([_, f]) => f(...args)), head);
}